import * as React from 'react';

import type { TranscriptionDialogContextValue } from './TranscriptionDialogContext';
import {
  TranscriptionDialogContext,
  TranscriptionDialogContextProvider,
} from './TranscriptionDialogContext';

const withTranscriptionDialogContextProvider = <T extends TranscriptionDialogContextValue>(
  Component: React.ComponentType<T>,
) =>
    (function TranscriptionParameterContextComponent(props: Pick<T, Exclude<keyof T, keyof TranscriptionDialogContextValue>>) {
      return (
        <TranscriptionDialogContextProvider>
          <TranscriptionDialogContext.Consumer>
            {(contexts) => <Component {...(props as T)} {...contexts} />}
          </TranscriptionDialogContext.Consumer>
        </TranscriptionDialogContextProvider>
      );
    });

export default withTranscriptionDialogContextProvider;
